//AuthProvider.tsx

import React, { useEffect, useState } from "react";
import { AuthContext, AuthUser } from "./hooks/useAuth";
import axios from "axios";

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser]       = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("/adriva_api/auth/me", { withCredentials: true })
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  // Register the global 401 handler once. The interceptor in API.ts calls this.
  useEffect(() => {
    (window as any).__adriva_onSessionExpired = () => {
      setUser(null);   // → AppRoutes re-renders → LoginPage
    };
    return () => { delete (window as any).__adriva_onSessionExpired; };
  }, []);

  function logout() {
    axios
      .post("/adriva_api/auth/logout", {}, { withCredentials: true })
      .finally(() => {
        setUser(null);
      });
  }

  return (
    <AuthContext.Provider value={{ user, loading, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}